module.exports = __webpack_public_path__ + "img/50.4128ce30.jpg";